export interface SweetItem {
  id: number;
  title: string;
  category: string;
  summary: string;
  tag: string;
  heat: number;
  likes: string;
  image: string;
  author: string;
  date: string;
  readMin: number;
}

export interface RankItem {
  id: number;
  title: string;
  tag: string;
  score: string;
  content: string;
}

export interface NavLink {
  label: string;
  href: string;
}

export const navLinks: NavLink[] = [
  { label: "首页", href: "#top" },
  { label: "高甜瓜料", href: "#gossip" },
  { label: "甜蜜榜单", href: "#rank" },
  { label: "甜蜜精选", href: "#picks" },
  { label: "吃瓜百科", href: "#guide" },
  { label: "口碑", href: "#review" },
  { label: "常见问题", href: "#faq" },
];

export const categories: string[] = ["全部", "高甜CP", "甜蜜爆料", "恋爱日常", "好物安利", "生活糖分", "情绪补给"];

export const hotItems: SweetItem[] = [
  {
    id: 1,
    title: "被全网嗑到的他们，甜度到底有多高？",
    category: "高甜CP",
    summary: "从擦肩到双向奔赴，那些藏不住的糖点细节盘点，看完只想大喊再来一集。",
    tag: "今日爆火",
    heat: 986,
    likes: "12.4w",
    image: "https://readdy.ai/api/search-image?query=warm%20coral%20toned%20lifestyle%20magazine%20photo%20of%20a%20sweet%20couple%20enjoying%20cream%20cake%20and%20coffee%20at%20a%20cozy%20cafe%2C%20soft%20natural%20light%2C%20airy%20editorial%20composition%2C%20candid%20and%20romantic%2C%20pastel%20background&width=900&height=640&seq=hot-gossip-01&orientation=landscape",
    author: "糖心编辑部",
    date: "今日",
    readMin: 4,
  },
  {
    id: 2,
    title: "吃瓜群众注意，这对的新糖又来了",
    category: "甜蜜爆料",
    summary: "同款手势、同色穿搭、默契问答，逐帧分析他们这次营业又藏了多少小心思。",
    tag: "爆款热读",
    heat: 812,
    likes: "8.9w",
    image: "https://readdy.ai/api/search-image?query=editorial%20photo%20two%20young%20asian%20friends%20laughing%20together%20sharing%20strawberry%20milk%20tea%20near%20a%20bright%20window%2C%20soft%20golden%20hour%20light%2C%20sweet%20playful%20mood%2C%20clean%20minimal%20backdrop&width=900&height=640&seq=hot-gossip-02&orientation=landscape",
    author: "蜜语小瓜",
    date: "今日",
    readMin: 5,
  },
  {
    id: 3,
    title: "三年又三年，他们的甜终于藏不住了",
    category: "高甜CP",
    summary: "从搭档到彼此，时间是最好的糖，网友整理的恋爱时间线让人直呼细节控狂喜。",
    tag: "全网热搜",
    heat: 763,
    likes: "6.7w",
    image: "https://readdy.ai/api/search-image?query=cinematic%20sweet%20portrait%20of%20two%20people%20walking%20hand%20in%20hand%20through%20a%20blossom%20park%20at%20sunset%2C%20warm%20peach%20tones%2C%20romantic%20atmosphere%2C%20editorial%20photography%2C%20soft%20bokeh&width=900&height=640&seq=hot-gossip-03&orientation=landscape",
    author: "糖分研究所",
    date: "昨天",
    readMin: 6,
  },
  {
    id: 4,
    title: "恋爱综艺里最上头的这对，现实也甜",
    category: "甜蜜爆料",
    summary: "节目外的小互动连更不断，综艺内外的糖到底哪边更浓？我们来聊聊。",
    tag: "高能甜料",
    heat: 701,
    likes: "5.3w",
    image: "https://readdy.ai/api/search-image?query=bright%20studio%20photo%20of%20couple%20wearing%20matching%20pastel%20outfits%20making%20heart%20gesture%20with%20hands%2C%20playful%20reality%20show%20set%2C%20fresh%20candy%20color%20palette%2C%20editorial%20lighting&width=900&height=640&seq=hot-gossip-04&orientation=landscape",
    author: "柚子雷达",
    date: "昨天",
    readMin: 4,
  },
  {
    id: 5,
    title: "高甜预警！这些瞬间甜到想磕墙",
    category: "生活糖分",
    summary: "陌生人的善意、朋友的偏爱、宠物的撒娇……生活里藏着的微小高甜时刻合集。",
    tag: "治愈系",
    heat: 654,
    likes: "4.2w",
    image: "https://readdy.ai/api/search-image?query=heartwarming%20lifestyle%20photo%20of%20a%20person%20hugging%20a%20fluffy%20cream%20colored%20cat%20on%20a%20sunny%20couch%2C%20soft%20warm%20morning%20light%2C%20cozy%20homey%20feeling%2C%20editorial%20minimal%20aesthetic&width=900&height=640&seq=hot-gossip-05&orientation=landscape",
    author: "暖糖少女",
    date: "前天",
    readMin: 3,
  },
  {
    id: 6,
    title: "追星也能很上头，这份高甜营业盘点请收好",
    category: "甜蜜爆料",
    summary: "眼神、互动、合照暗号，营业艺术家们的糖点合集，追星女孩必看。",
    tag: "粉丝热议",
    heat: 589,
    likes: "3.9w",
    image: "https://readdy.ai/api/search-image?query=vibrant%20concert%20light%20photo%20of%20fans%20holding%20glowing%20phone%20lights%20and%20banners%2C%20stage%20silhouette%20in%20coral%20and%20amber%20lights%2C%20exciting%20celebration%20energy%2C%20editorial%20wide%20shot&width=900&height=640&seq=hot-gossip-06&orientation=landscape",
    author: "舞台闪光",
    date: "前天",
    readMin: 5,
  },
];

export const rankItems: RankItem[] = [
  { id: 1, title: "年度最甜CP糖点盘点", tag: "高甜CP", score: "9.8", content: "从相遇到守护，逐帧整理他们藏不住的每一颗糖，看完只想说再来亿次。" },
  { id: 2, title: "高甜综艺名场面TOP10", tag: "高能甜料", score: "9.6", content: "那些甜到齁、让人反复回放的名场面，一次性给你凑齐。" },
  { id: 3, title: "恋爱日常里的心动细节", tag: "恋爱日常", score: "9.4", content: "藏在生活缝隙里的温柔与偏爱，才是最高级的甜。" },
  { id: 4, title: "甜蜜爆料里的暗号糖", tag: "甜蜜爆料", score: "9.2", content: "同款、呼应、隔空……那些只有粉丝能懂的默契时刻。" },
  { id: 5, title: "治愈情绪的低糖小故事", tag: "情绪补给", score: "9.0", content: "淡淡的甜，暖暖的心，适合睡前慢慢读的小故事合集。" },
  { id: 6, title: "会心一笑的甜蜜瞬间", tag: "生活糖分", score: "8.8", content: "在忙碌生活里，捕捉每个让人会心一笑的高甜瞬间。" },
];

export const pickItems: SweetItem[] = [
  {
    id: 7,
    title: "把喜欢藏在细节里的他们，真的好会",
    category: "高甜CP",
    summary: "有些糖不用大张旗鼓，藏在顺手夹的菜、记得的口味与无意识的靠近里。",
    tag: "精选",
    heat: 528,
    likes: "3.1w",
    image: "https://readdy.ai/api/search-image?query=soft%20romantic%20photo%20of%20hands%20sharing%20a%20bowl%20of%20warm%20soup%20on%20a%20cozy%20dining%20table%2C%20steam%20rising%2C%20warm%20amber%20evening%20light%2C%20intimate%20editorial%20food%20mood&width=800&height=520&seq=pick-01&orientation=landscape",
    author: "糖心编辑部",
    date: "本周精选",
    readMin: 5,
  },
  {
    id: 8,
    title: "一口气盘点：最近让人上头的三对",
    category: "甜蜜爆料",
    summary: "观众缘爆炸的三对，各自的高甜路线各不相同，谁才是你心中的糖王？",
    tag: "本周热选",
    heat: 476,
    likes: "2.8w",
    image: "https://readdy.ai/api/search-image?query=fun%20editorial%20collage%20mood%20photo%20of%20couple%20silhouettes%20near%20bright%20window%20curtains%2C%20pastel%20pink%20and%20cream%20tones%2C%20modern%20magazine%20aesthetic&width=800&height=520&seq=pick-02&orientation=landscape",
    author: "蜜语小瓜",
    date: "本周精选",
    readMin: 6,
  },
  {
    id: 9,
    title: "为什么我们总爱磕甜甜的故事？",
    category: "情绪补给",
    summary: "从心理学聊聊“嗑糖”背后的治愈力，为什么甜料让人上头又安心。",
    tag: "深度好文",
    heat: 421,
    likes: "2.1w",
    image: "https://readdy.ai/api/search-image?query=calm%20editorial%20photo%20of%20a%20cup%20of%20hot%20cocoa%20with%20marshmallows%20and%20an%20open%20notebook%20on%20a%20warm%20desk%2C%20soft%20morning%20light%2C%20thoughtful%20reading%20mood&width=800&height=520&seq=pick-03&orientation=landscape",
    author: "糖分研究所",
    date: "本周精选",
    readMin: 7,
  },
];

export const guideItems: { id: number; icon: string; title: string; desc: string }[] = [
  { id: 1, icon: "ri-magic-line", title: "新手怎么愉快吃瓜", desc: "第一次来也别慌，教你从榜单和精选入手，三分钟找到今日份糖分。" },
  { id: 2, icon: "ri-question-answer-line", title: "如何判断糖的真假", desc: "吃瓜虽甜也要理性，学会看时间线与多方视角，甜得安心不上头。" },
  { id: 3, icon: "ri-heart-add-line", title: "高甜CP的正确打开方式", desc: "从入门到资深，掌握嗑糖的正确姿势，守护自己的快乐小天地。" },
  { id: 4, icon: "ri-cup-line", title: "甜蜜分享与投稿", desc: "如果你也有想分享的高甜瞬间，欢迎告诉我们，一起把糖分扩散。" },
];

export interface Review {
  id: number;
  name: string;
  role: string;
  text: string;
  avatar: string;
}

export const reviews: Review[] = [
  { id: 1, name: "一颗糖栗子", role: "追星女孩", text: "每天睡前刷一刷真的会变开心，内容甜而不腻，看到喜欢的组合连更的时候真的会原地转圈！", avatar: "https://readdy.ai/api/search-image?query=soft%20round%20illustration%20avatar%20of%20a%20smiling%20asian%20girl%20with%20long%20hair%2C%20warm%20pastel%20coral%20background%2C%20cute%20flat%20style%20portrait&width=200&height=200&seq=avatar-1&orientation=squarish" },
  { id: 2, name: "半糖去冰", role: "高甜CP粉", text: "细节整理得超用心，时间线也清楚，追起来完全不迷路，是我关注列表里的宝藏号。", avatar: "https://readdy.ai/api/search-image?query=soft%20round%20illustration%20avatar%20of%20a%20smiling%20young%20man%20with%20short%20hair%20wearing%20glasses%2C%20warm%20peach%20background%2C%20cute%20flat%20style%20portrait&width=200&height=200&seq=avatar-2&orientation=squarish" },
  { id: 3, name: "椰子汽水", role: "生活博主", text: "不止是吃瓜，里面的治愈小故事和生活糖分也很对我胃口，看完心情都会变好。", avatar: "https://readdy.ai/api/search-image?query=soft%20round%20illustration%20avatar%20of%20a%20happy%20asian%20girl%20with%20hair%20bun%2C%20warm%20amber%20background%2C%20cute%20flat%20style%20portrait&width=200&height=200&seq=avatar-3&orientation=squarish" },
];

export const faqItems: { q: string; a: string }[] = [
  { q: "吃瓜糖心是做什么的？", a: "吃瓜糖心是一站式的高甜瓜料与甜蜜爆料内容站，专注整理娱乐圈高甜瞬间、甜蜜日常与治愈系生活故事，用轻松、有趣的方式帮你轻松补充今日份糖分。" },
  { q: "内容多久更新一次？", a: "我们保持高频更新，热门瓜料、高甜榜单与甜蜜精选几乎每日都有新内容，你可以按刷新频率常来逛逛，订阅后也能第一时间收到推送提醒。" },
  { q: "如何投稿或分享我的甜蜜瞬间？", a: "如果你也有想分享的高甜 CP 时刻、恋爱小日常或治愈故事，可以通过页面底部的投稿表单发给我们，经编辑部精选后会发布到对应栏目。" },
  { q: "内容是否客观可信？", a: "我们坚持信息整理尽量客观，涉及八卦会标注“爆料/网传”等属性并鼓励多方视角，同时也注重不造谣、不恶意揣测，甜要甜得理性。" },
  { q: "需要付费才能阅读吗？", a: "完全免费。所有内容对读者免费开放，我们希望每个人都能轻松获取快乐与治愈，不带任何阅读门槛。" },
];

export const footerNav: { title: string; links: string[] }[] = [
  { title: "栏目导航", links: ["高甜瓜料", "甜蜜榜单", "甜蜜精选", "吃瓜百科"] },
  { title: "帮助支持", links: ["投稿指南", "版权声明", "内容规范", "联系合作"] },
  { title: "关于我们", links: ["品牌故事", "编辑部", "更新动态", "隐私政策"] },
];